import InputFIeld from "components/form/input-field/input-field.component";
import SideModal from "components/modal/side-modal/side-modal.component";
import { useState, useEffect, useGlobal } from "reactn";
import ToggleButton from "components/form/toggle-button/toggle-button.component";
import Button from "components/button/button.component";
import { Modal } from "react-bootstrap";
import { createTool, updateTool } from "api/services/tool.service";
import Select from "components/form/select/select.component";

const ToolModal = ({ show, tool, motivationList, onHide }) => {
  const [currentUser] = useGlobal("currentUser");

  const [name, setName] = useState("");
  const [motivation, setMotivation] = useState(null);
  const [disabled, setDisabled] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (tool) {
      setName(tool.name);
      setDisabled(tool.disabled);
      setMotivation(tool.motivation);
    } else {
      setName("");
      setDisabled(false);
      setMotivation(null);
    }

    setLoading(false);
    setError(null);
  }, [tool]);

  const onPublishTool = async () => {
    setError(null);
    setLoading(true);

    let data = {
      name: name,
      disabled: disabled,
    };

    if (motivation) data["motivation_id"] = motivation.id;

    if (tool) {
      // update
      const reponse = await updateTool({
        authToken: currentUser.token.actual,
        id: tool.id,
        data: data,
      });

      setLoading(false);

      if (reponse.success) {
        onHide(true);

        return;
      }

      setError(reponse.message);
    } else {
      // create new one
      const reponse = await createTool({
        authToken: currentUser.token.actual,
        data: data,
      });

      setLoading(false);

      if (reponse.success) {
        onHide(true);

        return;
      }

      setError(reponse.message);
    }
  };

  return (
    <SideModal
      show={show}
      onHide={() => {
        // reset();
        onHide();
      }}
      onBlurHide={false}>
      <Modal.Body className="scrollbar">
        <div className="modal-inner">
          <div className="content-medium">
            <div className="text-dark text-20 font-bold mb-30">
              {tool ? "Edit " : "Add new "} tool
            </div>

            <div className="mb-20">
              <InputFIeld
                label="Name"
                placeholder={"eg. Figma"}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="mb-20">
              <Select
                label="Motivation (Optional)"
                placeholder="Select motivation"
                value={[
                  {
                    label: motivation
                      ? motivation.description
                      : "Select motivation",
                    value: motivation ? motivation.id : "",
                  },
                ]}
                options={
                  motivationList
                    ? [
                        { label: "Select motivation", value: "" },
                        ...motivationList
                          .filter((m) => !m.disabled)
                          .map((motivationItem) => {
                            return {
                              label: motivationItem.description,
                              value: motivationItem.id,
                            };
                          }),
                      ]
                    : []
                }
                onChange={(selected) => {
                  setMotivation(
                    motivationList.find((item) => item.id === selected.value)
                  );
                }}
              />
              <p className="text-grey-dark text-14 mt-10">
                When you select a motivation for a tool, a topic pack is
                automatically created for it. This allows mentors and mentees to
                be able to select this tool as a topic for mentorship sessions.
                {tool && (
                  <span className="text-danger">
                    <br /> <br />
                    NB: Removing an already set motivation will automatically
                    delete any topic pack created for this tool.
                  </span>
                )}
              </p>
            </div>

            <div>
              <ToggleButton
                label="Disabled"
                checked={disabled}
                onChange={(value) => {
                  setDisabled(value);
                }}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div
          className="modal-footer-inner"
          style={{ paddingBottom: `${window.bottomSpace}` }}>
          {error && !loading && (
            <div className="text-danger text-16 mb-10">{error}</div>
          )}

          <div className="d-flex">
            <Button
              classes="small secondary mr-2"
              loading={loading}
              disabled={name.length === 0 || loading}
              onClick={onPublishTool}>
              Publish
            </Button>
            <Button
              classes="small info"
              disabled={loading}
              onClick={() => {
                // reset();
                onHide();
              }}>
              Cancel
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </SideModal>
  );
};

export default ToolModal;
